/* Fransk katalog for locale-investment-inbox.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'investments.inboxTitle': 'Boîte de réception',
  'investments.inboxIntro': 'Importez les documents d\'achat et de vente de fonds et d\'actions. Plumme lit le document et prépare l\'enregistrement.',
  'investments.supportNotice': 'Les fonds et les actions sont entièrement pris en charge pour l\'enregistrement et la comptabilisation. D\'autres types de placements peuvent être reconnus, mais doivent pour l\'instant être traités manuellement.',
  'investments.sendToEmail': 'Envoyer à',
  'investments.copyEmail': 'Copier l\'adresse e-mail',
  'investments.folder': 'Dossier',
  'investments.inboxFolder': 'Boîte de réception',
  'investments.trashFolder': 'Corbeille',
  'investments.documentationFolder': 'Documentation',
  'investments.searchDocuments': 'Rechercher dans les documents',
  'investments.emptyFolder': 'Ce dossier ne contient aucun document.',
  'investments.documentNotAnalyzed': 'Prêt pour l\'analyse',
  'investments.superPlummaProposal': 'Suggestion de SuperPlumma',
  'investments.reviewAndApprove': 'Vérifier et valider',
  'investments.notAnalyzedHelp': 'Le document a été reçu et est prêt pour l\'analyse.',
  'investments.restoreDocument': 'Restaurer',
  'investments.sendToDocumentation': 'Envoyer vers Documentation',
  'investments.moveToTrash': 'Mettre à la corbeille',
  'investments.moreActions': 'Plus d\'actions',
  'investments.registerPurchase': 'Enregistrer un achat',
  'investments.registerSale': 'Enregistrer une vente',
  'investments.tradeDate': 'Date de transaction',
  'investments.unitPrice': 'VL / cours',
  'investments.previewDocumentFallback': 'Document',
  'investments.previewMissingFileLink': 'Lien de fichier manquant',
  'investments.openDocument': 'Ouvrir le document',
  'investments.addBankAccount': '+ Ajouter un compte bancaire …',
  'investments.addBankTitle': 'Ajouter un compte bancaire',
  'investments.addBankSave': 'Ajouter le compte',
  'investments.newBankAccountNote': 'Un nouveau compte bancaire est créé dans le plan comptable',
  'investments.newBankAccountCode': 'Le compte bancaire reçoit le prochain compte disponible de la série 192x : {{code}}.',
  'investments.bankName': 'Nom du compte',
  'investments.bankNamePlaceholder': 'Ex. Compte d\'investissement',
  'investments.bankAccountNumber': 'Numéro de compte',
  'investments.openingBalance': 'Solde d\'ouverture',
  'investments.openingBalanceDate': 'Date du solde d\'ouverture',
  'investments.bankNameRequired': 'Donnez un nom au compte bancaire.',
  'investments.bankNumberRequired': 'Saisissez le numéro de compte.',
  'investments.bankOpeningRequired': 'Saisissez le solde d\'ouverture et sa date. Saisissez 0 si le solde était nul.',
  'investments.bankNumberExists': 'Ce compte bancaire est déjà enregistré.',
  'investments.bankLedgerSeriesFull': 'Aucun compte n\'est disponible dans la série 192x. Ajoutez le compte dans Paramètres.',
  'investments.bankAdded': 'Compte bancaire ajouté.',
  'investments.addBankFailed': 'Impossible d\'ajouter le compte bancaire.',
  'investments.addBankUnavailable': 'Les comptes bancaires ne sont pas connectés au backend.',
  'investments.addBankUnsupportedCountry': 'Ce flux de compte bancaire n\'est pour l\'instant pris en charge que pour les entreprises norvégiennes.',
  'investments.newInvestmentAccount': 'Nouveau compte d\'investissement',
  'investments.investmentAccounts': 'Comptes d\'investissement et comptes-titres',
  'investments.settingsTab': 'Investissements',
  'investments.settingsTitle': 'Comptes d\'investissement et comptes-titres',
  'investments.settingsHelp': 'Gérez les comptes auprès des banques, sociétés de gestion et autres fournisseurs.',
  'investments.editInvestmentAccount': 'Modifier le compte d\'investissement',
  'investments.investmentAccountsHelp': 'Enregistrez les comptes auprès de chaque fournisseur. Un même placement peut être détenu sur plusieurs comptes-titres, tandis que le compte du grand livre reste à quatre chiffres.',
  'investments.noInvestmentAccounts': 'Aucun compte d\'investissement enregistré pour l\'instant.',
  'investments.saveInvestmentAccount': 'Enregistrer le compte d\'investissement',
  'investments.investmentAccountId': 'Banque / compte-titres',
  'investments.targetInvestmentAccountId': 'Nouvelle banque / nouveau compte-titres',
  'investments.accountNumber': 'Numéro de compte ou de compte-titres (facultatif)',
  'investments.defaultSettlementAccount': 'Compte de règlement par défaut',
  'investments.noDefaultSettlementAccount': 'Aucun compte de règlement par défaut',
  'investments.accountActive': 'Le compte d\'investissement est actif',
  'investments.custody': 'Compte-titres',
  'investments.fund_account': 'Compte de fonds',
  'investments.other': 'Autre compte d\'investissement',
  'investments.subledgerCode': 'Numéro d\'investissement interne',
  'investments.createInstrumentFromDocument': '{{name}} (créé à l\'enregistrement)',
  'investments.providerHelp': 'Où le placement est détenu, par exemple Storebrand ou Nordnet. Indiquez le numéro de compte-titres le cas échéant.',
  'investments.settlementAccountHelp': 'Le compte de l\'entreprise débité ou crédité. Un compte espèces chez le fournisseur doit être enregistré comme compte bancaire/de règlement distinct dans Paramètres. Une AS ne peut pas utiliser un compte d\'épargne en actions personnel (ASK).',
  'investments.investmentAccountInvalid': 'Vérifiez le nom, le fournisseur et le type de compte.',
  'investments.investmentAccountNotFound': 'Le compte d\'investissement est introuvable ou inactif.',
  'investments.investmentAccountDuplicate': 'Un compte d\'investissement portant le même nom existe déjà.',
  'investments.investmentAccountRequired': 'Choisissez un compte d\'investissement lorsque le fournisseur a plusieurs comptes.',
  'investments.investmentAccountQuantityInvalid': 'Le compte-titres choisi ne détient pas assez de parts enregistrées pour cet événement.',
});
